<template>
   <div class="list complaints_List feedBack_list">
   	 <ul class="list">
        <li @click="selected('good')" v-bind:class='{on:resultFeedBack==1}'>
          <span class="feedBack_con fl">满意</span><span class="feedBack_icon fr"></span>
        </li>
        <li @click="selected('bad')" v-bind:class='{on:resultFeedBack==2}'>
           <span class="feedBack_con fl">不满意</span><span class="feedBack_icon fr"></span>
        </li>
     </ul>
     <div class="feedBack_submit" @click="submit">提交</div>
   </div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { Toast } from 'mint-ui'

  export default {
    data () {
      return {
          complainId: window.localStorage.getItem('complainId'),
          resultFeedBack: 1
        }
    },
    // created () {
    //   document.title = '投诉结果反馈'
    // },
    methods: {
      selected: function (data){
        var _this = this
          if(data === 'good'){
            if(_this.resultFeedBack !== 1) {
                _this.resultFeedBack = 1
            }
          }else if(data === 'bad'){
            if(_this.resultFeedBack !== 2) {
               _this.resultFeedBack = 2
            }
          }

      },
      submit: function (){
        var _this = this
        var params = {
            complainId: _this.complainId,
            resultFeedBack: _this.resultFeedBack
        }
        window.localStorage.setItem('complainId', _this.complainId),
        actions.postFeedBack(_this, params, function () {
            //提交反馈成功
            _this.$router.go(-1);

        },function (response){
          _this.$toast(response.body.message)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FeedBack.vue?4b78c566